import React from 'react';
import styled from 'styled-components';
import { HeadlineOne, Paragraph } from 'components/atoms/SectionWrapper.style';
import { cms } from 'assets/cms';

const ElementsWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  @media ${({ theme }) => theme.media.tablet} {
    flex-direction: row;
  }
  div {
    margin: 10px auto;
    padding: 10px;

    @media ${({ theme }) => theme.media.tablet} {
      margin: 10px auto;
    }
  }
`;

const PhotovoltaicsIconsWrapper = styled(ElementsWrapper)`
  margin-top: 50px;
  img {
    height: 50px;
  }
`;

const EditElementsWrapper = () => (
  <>
    <PhotovoltaicsIconsWrapper>
      <div>
        <img src={cms.icons.pv1} alt="Power" />
        <HeadlineOne>72 komórki</HeadlineOne>
        <Paragraph>Moduł wielokrystaliczny</Paragraph>
      </div>
      <div>
        <img src={cms.icons.pv2} alt="Star" />
        <HeadlineOne>320-335W</HeadlineOne>
        <Paragraph>Zakres mocy wyjściowej</Paragraph>
      </div>
      <div>
        <img src={cms.icons.pv3} alt="Book" />
        <HeadlineOne>17.1%</HeadlineOne>
        <Paragraph>Maksymalna efektywność</Paragraph>
      </div>
      <div>
        <img src={cms.icons.pv4} alt="Technology" />
        <HeadlineOne>0~+5W</HeadlineOne>
        <Paragraph>Tolerancja mocy wyjściowej</Paragraph>
      </div>
    </PhotovoltaicsIconsWrapper>
  </>
);

export default EditElementsWrapper;
